export default __webpack_public_path__ + "static/media/logo.5b9e6b6e.png";